import React from "react";
import PropTypes from "prop-types";
import AppSwitch from "@coreui/react/lib/Switch";
import {useTranslation} from "react-i18next";

function ApplicationSwitch(props) {
  const { t } = useTranslation('application_switch');
  return <AppSwitch dataOn={props.dataOn ?? t('data_yes')} dataOff={props.dataOff ?? t('data_no')} {...props} />
};

ApplicationSwitch.propTypes = {
  color: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  dataOn: PropTypes.string,
  dataOff: PropTypes.string,
};

export default ApplicationSwitch;